const ABORTED_NETWORK_ERROR_MESSAGES = new Set([
  "failed to fetch",
  "load failed",
  "the operation was aborted",
  "signal is aborted without reason",
  "network error",
]);

export function isAbortedNetworkError(error: Error): boolean {
  if ("statusCode" in error) {
    return false;
  }
  const normalizedMessage = error.message.toLowerCase().replace(/\.$/, "");
  return ABORTED_NETWORK_ERROR_MESSAGES.has(normalizedMessage);
}

type GraphQLErrorLike = {
  message: string;
  extensions?: { code?: string };
};

type ApolloErrorLike = {
  graphQLErrors?: GraphQLErrorLike[];
};

export const getClientSafeErrorMessage = (error: unknown): string | null => {
  const apolloError = error as ApolloErrorLike;
  if (apolloError?.graphQLErrors && Array.isArray(apolloError.graphQLErrors)) {
    const clientSafeError = apolloError.graphQLErrors.find(
      (e) => e.extensions?.code === "CLIENT_SAFE_ERROR",
    );
    return clientSafeError?.message ?? null;
  }
  return null;
};

export function isNotAuthorizedGraphQLError(error: {
  message: string;
  extensions?: { code?: string };
}): boolean {
  return (
    error.message === "Not authorized" &&
    error.extensions?.code === "CLIENT_SAFE_ERROR"
  );
}
